const findItemByKey = (keyToFind: string, itemList) => {
  for (const item of itemList) {
    if (item.key === keyToFind) {
      // Item found in the current level
      return item;
    }

    if (item.children && Array.isArray(item.children)) {
      const childResult = findItemByKey(keyToFind, item.children);
      if (childResult) {
        // Item found in the children array
        return childResult;
      }
    }
  }

  // Item not found
  return null;
};

export default findItemByKey;
